import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import RcMenu, { Divider, ItemGroup } from 'rc-menu';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { KeyCode } from '../../wui-core/src';
import { ConfigContext } from './config-provider';
import SubMenu from './SubMenu';
import Item from './MenuItem';
import collapseMotion from './_util/motion';
import omit from 'omit.js';
import { cloneElement } from './_util/reactNode';
import MenuContext from './config-provider/MenuContext';
var RcMenuProps = RcMenu.propTypes;
var popupPlacementMap = {
  'rightTop': 'vertical-left',
  'leftTop': 'vertical-right'
};

var InternalMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(InternalMenu, _React$Component);

  var _super = _createSuper(InternalMenu);

  function InternalMenu(props) {
    var _this;

    _classCallCheck(this, InternalMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getInlineCollapsed", function () {
      var _this$props = _this.props,
          inlineCollapsed = _this$props.inlineCollapsed,
          siderCollapsed = _this$props.siderCollapsed;

      if (siderCollapsed !== undefined) {
        return siderCollapsed;
      }

      return inlineCollapsed;
    });

    _defineProperty(_assertThisInitialized(_this), "flatAllMenuItem", function (children) {
      children.forEach(function (child) {
        if (child && child.props && child.props.children && Array.isArray(child.props.children) && child.props.children.length) {
          _this.flatAllMenuItem(child.props.children);
        }

        _this.childreArr.push(child);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedKey", function (key, activeKey) {
      var item = _this.childreArr.find(function (item) {
        return item.key && item.key === key;
      });

      if (item && item.type.name === 'MenuItem') {
        return key;
      }

      if (item && item.type.name === 'SubMenu') {
        return _this.getSelectedKey(activeKey["".concat(key, "-menu-")], activeKey);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var menuRef = _this.menuRef;

      if (e.keyCode === KeyCode.ENTER) {
        var store = menuRef.store;

        var _store$getState = store.getState(),
            activeKey = _store$getState.activeKey,
            selectedKeys = _store$getState.selectedKeys; // current active menu item's key


        var menuKey = activeKey['0-menu-'];

        var selectedKey = _this.getSelectedKey(menuKey, activeKey);

        var newSelectedKeys = _toConsumableArray(selectedKeys);

        if (menuRef.props.multiple) {
          newSelectedKeys = newSelectedKeys.includes(selectedKey) ? newSelectedKeys : [].concat(_toConsumableArray(selectedKeys), [selectedKey]);
        } else {
          newSelectedKeys = [selectedKey];
        }

        store.setState({
          selectedKeys: newSelectedKeys
        });
      }
    });

    _this.menuRef = null; // menu 下的所有节点

    _this.childreArr = [];
    return _this;
  }

  _createClass(InternalMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.keyboard && this.menuRef) {
        this.flatAllMenuItem(this.menuRef.props.children);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var getPrefixCls = this.context.getPrefixCls; // const rootPrefixCls = getPrefixCls();

      var _this$props2 = this.props,
          customizePrefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          theme = _this$props2.theme,
          expandIcon = _this$props2.expandIcon,
          getPopupContainer = _this$props2.getPopupContainer,
          direction = _this$props2.direction,
          keyboard = _this$props2.keyboard,
          onKeyDown = _this$props2.onKeyDown,
          position = _this$props2.position,
          mode = _this$props2.mode; // const defaultMotions = {
      //   horizontal: { motionName: `slide-up` },
      //   inline: collapseMotion,
      //   other: { motionName: `zoom-big` },
      // };

      var domProps = {
        onKeyDown: onKeyDown ? onKeyDown : keyboard ? this.onKeyDown : null
      };
      var prefixCls = getPrefixCls('menu', customizePrefixCls);
      var menuClassName = classNames("".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), this.getInlineCollapsed()), className);
      return /*#__PURE__*/React.createElement(MenuContext.Provider, {
        value: {
          inlineCollapsed: this.getInlineCollapsed() || false,
          menuTheme: theme,
          direction: direction
        }
      }, /*#__PURE__*/React.createElement("div", domProps, /*#__PURE__*/React.createElement(RcMenu, _extends({
        getPopupContainer: getPopupContainer
      }, omit(this.props, ['keyboard', 'onKeyDown', 'vertical']), {
        mode: position && popupPlacementMap[position] ? popupPlacementMap[position] : mode,
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        ref: function ref(c) {
          return _this2.menuRef = c;
        } // defaultmotions={defaultMotions}
        ,
        expandIcon: cloneElement(expandIcon, {
          className: "".concat(prefixCls, "-submenu-expand-icon")
        })
      }))));
    }
  }]);

  return InternalMenu;
}(React.Component); // We should keep this as ref-able


_defineProperty(InternalMenu, "propTypes", _objectSpread(_objectSpread({}, RcMenuProps), {}, {
  theme: PropTypes.oneOf(['light', 'dark']),
  inlineIndent: PropTypes.number,
  focusable: PropTypes.bool,
  keyboard: PropTypes.bool,
  mode: PropTypes.oneOf(['vertical', 'vertical-left', 'vertical-right', 'horizontal', 'inline']),
  position: PropTypes.oneOf(['leftTop', 'rightTop'])
}));

_defineProperty(InternalMenu, "defaultProps", {
  className: '',
  // 自定义类名
  theme: 'light',
  // 主题颜色
  focusable: true,
  // menu 菜单是否可以聚焦，默认可以
  mode: 'vertical',
  // 菜单类型，对外使用vertical horizontal inline
  keyboard: false,
  // 是否使用键盘操作
  inlineIndent: 24 // position: 'rightTop', // 子菜单呼出位置，在vertical模式下使用
  // selectedKeys: [], // 当前选中的菜单项 key 数组
  // defaultSelectedKeys: [], // 初始选中的菜单项 key 数组
  // openKeys: [], // 当前展开的 SubMenu 菜单项 key 数组
  // defaultOpenKeys: [], // 初始展开的 SubMenu 菜单项 key 数组
  // onOpenChange: null, // SubMenu 展开/关闭的回调 Function(openKeys: string[])
  // onSelect: null, // 被选中时调用
  // onDeselect: null, // 取消选中时调用，仅在 multiple 生效
  // onClick: null, // 点击 menuitem 调用此函数，参数为 {item, key, keyPath}
  // onKeyDown: null, // 键盘操作回调函数,
  // tabIndex: '0', // 设置tabIndex
  // children: null, // MenuItem组件/SubMenu组件/MenuItemGroup组件

});

_defineProperty(InternalMenu, "contextType", ConfigContext);

var Menu = /*#__PURE__*/function (_React$Component2) {
  _inherits(Menu, _React$Component2);

  var _super2 = _createSuper(Menu);

  function Menu() {
    _classCallCheck(this, Menu);

    return _super2.apply(this, arguments);
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(InternalMenu, this.props);
    }
  }]);

  return Menu;
}(React.Component);

_defineProperty(Menu, "Divider", Divider);

_defineProperty(Menu, "Item", Item);

_defineProperty(Menu, "SubMenu", SubMenu);

_defineProperty(Menu, "ItemGroup", ItemGroup);

export default Menu;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-menu/src/index.js